import { useFormInputs, UseFormInputsOptions, useUpdateEffect } from '@lbcamden/lib-react';

import { ChildFormRoot } from './ChildForm.styled';

export type ChildFormProps<TData extends object> = Pick<
  UseFormInputsOptions<TData>,
  'schema' | 'config' | 'value' | 'disabled' | 'showErrors'
> & {
  onChange(data: Partial<TData>): void;
};

export const ChildForm = <TData extends object>({
  schema,
  config,
  value,
  showErrors,
  onChange,
}: ChildFormProps<TData>) => {
  const {
    formInputs,
    formState: { data },
  } = useFormInputs({
    schema,
    config,
    initialValue: value,
    showErrors,
  });

  useUpdateEffect(() => {
    onChange(data);
  }, [data]);

  return <ChildFormRoot>{formInputs}</ChildFormRoot>;
};
